import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/cashflows`;

// CREATE =>  POST: add a new product to the server
export function createCashFlow(cashflow) {
    return axios.post(API_URL, { ...cashflow });
}

// READ
export function getAllCashFlows() {
    return axios.get(API_URL);
}

export function getPaginatedCashFlows(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getCashFlowById(cashflowId) {
    return axios.get(`${API_URL}/${cashflowId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the cashflow on the server
export function updateCashFlow(cashflowId, cashflow) {
    return axios.put(`${API_URL}/${cashflowId}`, { ...cashflow });
}


// DELETE => delete the product from the server
export function deleteCashFlow(cashflowId) {
    return axios.delete(`${API_URL}/${cashflowId}`);
}
